export default __webpack_public_path__ + "static/media/marker_red.e2cbbc3d.svg";